import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import Search from "../search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import "./privacy_policy.scss";

const PrivacyPolicy = () => {
  const [privacypolicy, setprivacypolicy] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 8;
  const productsPerList = 50;
  const pagesVisited = pageNumber * productsPerPage;
  let displayprivacypolicy = [];
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    // console.log(selected);
    setPageNumber(selected);
  };

  useEffect(() => {
    axios
      .get("privacy_policy/all")
      .then((res) => {
        setprivacypolicy(res?.data);
        setFiltered(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      });
  }, []);

  return (
    <div className="privacy_policy p-5 text-left">
      <div className="page-title ">
        <h1>Privacy Policy Management</h1>
      </div>
      <div className="row ml-n4 search">
        <div className="col-md-9">
          <Search
            data={privacypolicy}
            title="PrivacyPolicy"
            filtered={setFiltered}
            setPageNumber={setPageNumber}
          />
        </div>

        <div className="col-md-3">
          <Link to="/privacy_policy/add" className="myButton">
            Add New
          </Link>
        </div>
      </div>

      <div className="listimi-tabela">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="listimi-head">
              <div className="row ">
                <div className="col-1">ID</div>
                <div className="col-4">Privacy policy:</div>
                <div className="col-2">Translations:</div>
                <div className="col-1">ALB</div>
                <div className="col-1">SRB</div>
                <div className="col-1">ENG</div>
                <div className="col-1 hideme"> </div>
              </div>
            </div>{" "}
            {
              (displayprivacypolicy = filtered
                ?.slice(pagesVisited, pagesVisited + productsPerPage)
                ?.map((filtered) => {
                  return (
                    <div className="listimi showme" key={filtered.id}>
                      <div className="row ">
                        <div className="col-1">{filtered.id} </div>
                        <div className="col-6">
                          {/* {filtered.content_al.slice(0, 50)} */}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: filtered?.content_al.slice(0, 50),
                            }}
                          ></div>
                        </div>

                        <div className="col-1">
                          {filtered.content_al === null ||
                            filtered.content_al === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}
                        </div>

                        <div className="col-1">
                          {filtered.content_sr === null ||
                            filtered.content_sr === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}
                        </div>

                        <div className="col-1">
                          {filtered.content_en === null ||
                            filtered.content_en === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}
                        </div>

                        <div className="col-1 delete">
                          <Link
                            className={"fa fa-trash"}
                            to={"/privacy_policy/delete/" + filtered.id}
                          ></Link>
                        </div>

                        <div className="col-1 edit">
                          <Link
                            className={"fa fa-edit"}
                            to={"/privacy_policy/edit/" + filtered.id}
                          ></Link>
                        </div>
                      </div>
                    </div>
                  );
                }))
            }
          </>
        )}
      </div>
      <div className="row mt-5">
        <div className="col-12">
          {privacypolicy.length >= productsPerPage ? (
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
